import { render } from "./CurrentUser.vue?vue&type=template&id=5eb834ba&scoped=true"
import script from "./CurrentUser.vue?vue&type=script&lang=js"
export * from "./CurrentUser.vue?vue&type=script&lang=js"

import "./CurrentUser.vue?vue&type=style&index=0&id=5eb834ba&lang=scss&scoped=true"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb834ba"]])

export default __exports__